export const MESSAGES = {
  couldNotLoad: `Couldn't load`,
  issueNotFound: 'Issue not found',
  issueNotFoundDescription: 'This issue does not exist or has been deleted.',
  deleteIssueConfirmationTitle: 'Delete issue?',
  deleteIssueConfirmationActionPoints: [
    'This cannot be undone',
    'Only adminstrators can delete issues',
    'Deletion will remove the issue from search and previous references will point to a placeholder',
  ],
  deleteIssueConfirmationButton: 'Delete',
  issueTimelineInTransfer: 'Issue timeline is being transferred.',
}
